import { ContainerModule } from 'inversify';
import {
  ObjectCompletionHandlerInterface,
  ObjectCompletionHandlerSymbol
} from './handlers/object-completion-handler-interface';
import { handlers } from './handlers/object-completion-handlers';
import { SectionScrollService, SectionScrollServiceSymbol } from './section/section-scroll-service';
import { SectionProgressInterface, SectionProgressSymbol } from '@/app/statistics/section/section-progress';
import { SectionProgressUtilsSymbol, SectionProgressUtils } from '@/app/statistics/section/section-progress-utils';
import { SectionProgressService } from '@/app/statistics/section/section-progress-service';
import { SaveSectionInteraction } from './listeners/save-section-interaction';
import { SetObjectCompleted } from './listeners/set-object-completed';
import { EventStreamListenerSymbol } from '@/app/event-stream';
import { SectionNavigationService, SectionNavigationServiceSymbol } from './section/section-navigation-service';
import { SectionDuration, SectionDurationSymbol } from './section/section-duration';

export const statisticsModule = new ContainerModule((bind) => {
  handlers.forEach((h) => {
    bind<ObjectCompletionHandlerInterface>(ObjectCompletionHandlerSymbol).to(h);
  });

  bind<SectionScrollService>(SectionScrollServiceSymbol).to(SectionScrollService).inSingletonScope();
  bind<SectionProgressInterface>(SectionProgressSymbol).to(SectionProgressService).inSingletonScope();
  bind<SectionProgressUtils>(SectionProgressUtilsSymbol).to(SectionProgressUtils).inSingletonScope();

  bind(SaveSectionInteraction).toSelf().inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(SaveSectionInteraction));

  bind(SetObjectCompleted).toSelf().inSingletonScope();
  bind(EventStreamListenerSymbol).toDynamicValue((c) => c.container.get(SetObjectCompleted));

  bind<SectionNavigationService>(SectionNavigationServiceSymbol).to(SectionNavigationService).inSingletonScope();
  bind<SectionDuration>(SectionDurationSymbol).to(SectionDuration).inSingletonScope();
});
